import { render, staticRenderFns } from "./project-selection-dialog.component.vue?vue&type=template&id=a4cff572"
import script from "./project-selection-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./project-selection-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports